export const cssProps = [
    // 'background',
    'backgroundColor',
    'backgroundImage',
    'backgroundPosition',
    'backgroundRepeat',
    'backgroundSize',
    'border',
    'borderBottom',
    'borderBottomColor',
    'borderBottomStyle',
    'borderBottomWidth',
    'borderColor',
    'borderLeftColor',
    'borderLeftStyle',
    'borderLeftWidth',
    'borderRight',
    'borderRightColor',
    'borderRightStyle',
    'borderRightWidth',
    'borderStyle',
    'borderTopColor',
    'borderTopStyle',
    'borderTopWidth',
    'borderWidth',
    'borderRadius',
    'color',
    'overflow',
    'display',
    'filter',
    'float',
    'font',
    'fontFamily',
    'fontUrl',
    'fontSize',
    'fontVariant',
    'fontWeight',
    'height',
    'width',
    'left',
    'right',
    'top',
    'bottom',
    'opacity',
    'lineHeight',
    'margin',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'position',
    'padding',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'textDecoration',
    'textAlign',
    'visibility',
    'zIndex'
];

export const getParsedCssProps = () => {
    let result = {};
    cssPropsArr.forEach(item => {
        result[item.name] = item;
    });
    return result;
};

export const cssPropsArr = [
    {
        name: 'align-content',
        type: 'select',
        options: [
            'stretch',
            'center',
            'flex-start',
            'flex-end',
            'space-between',
            'space-around',
            'initial',
            'inherit'
        ],
        help: 'align-content: stretch|center|flex-start|flex-end|space-between|space-around|initial|inherit;'
    },
    {
        name: 'align-items',
        type: 'select',
        options: [
            'stretch',
            'center',
            'flex-start',
            'flex-end',
            'baseline',
            'initial',
            'inherit'
        ],
        help: 'align-items: stretch|center|flex-start|flex-end|baseline|initial|inherit;'
    },
    {
        name: 'align-self',
        type: 'select',
        options: [
            'auto',
            'stretch',
            'center',
            'flex-start',
            'flex-end',
            'baseline',
            'initial',
            'inherit'
        ],
        help: 'align-self: auto|stretch|center|flex-start|flex-end|baseline|initial|inherit;'
    },
    // {
    //     name: 'background',
    //     type: 'text',
    //     help: 'background: bg-color bg-image position/bg-size bg-repeat bg-origin bg-clip bg-attachment initial|inherit;'
    // },
    {
        name: 'background-color',
        type: 'text',
        showPicker: true,
        help: 'accepts hash values: #fff030 & rgb values rgb(255, 255, 100) as well as named colors like: red'
    },
    {
        name: 'background-image',
        type: 'text'
    },
    {
        name: 'background-image-mask',
        type: 'text'
    },
    {
        name: 'background-position',
        type: 'select',
        options: [
            'left top',
            'left center',
            'left bottom',
            'right top',
            'right center',
            'right bottom',
            'center top',
            'center center',
            'center bottom'
        ]
    },
    {
        name: 'background-origin',
        type: 'select',
        options: [
            'padding-box',
            'border-box',
            'content-box',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'background-repeat',
        type: 'select',
        options: [
            'repeat',
            'repeat-x',
            'repeat-y',
            'no-repeat',
            'space',
            'round',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'background-size',
        type: 'select',
        options: [
            'auto',
            'length',
            'percentage',
            'cover',
            'contain',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'pointer-events',
        type: 'select',
        options: [
            'auto',
            'none',
            'all'
        ]
    },
    {
        name: 'border',
        type: 'text',
        help: 'border: border-width border-style border-color|initial|inherit;'
    },
    {
        name: 'border-bottom',
        type: 'text',
        help: 'border-bottom: border-width border-style border-color|initial|inherit;'
    },
    {
        name: 'border-right',
        type: 'text',
        help: 'border-right: border-width border-style border-color|initial|inherit;'
    },
    {
        name: 'border-left',
        type: 'text',
        help: 'border-left: border-width border-style border-color|initial|inherit;'
    },
    {
        name: 'border-top',
        type: 'text',
        help: 'border-top: border-width border-style border-color|initial|inherit;'
    },
    {
        name: 'border-image',
        type: 'text',
        help: 'border-image: source url(example.png) slice width outset repeat|initial|inherit;;'
    },
    {
        name: 'border-radius',
        type: 'text',
        help: 'border-radius: 1-4 length|% / 1-4 length|%|initial|inherit;'
    },
    {
        name: 'border-width',
        type: 'text',
        help: 'border-width: px'
    },
    {
        name: 'box-sizing',
        type: 'select',
        options: [
            'content-box',
            'border-box',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'color',
        type: 'text',
        showPicker: true
    },
    {
        name: 'display',
        type: 'select',
        options: [
            'inline',
            'block',
            'flex',
            'inline-block',
            'inline-flex',
            'table',
            'table-cell',
            'none',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'float',
        type: 'select',
        options: [
            'none',
            'left',
            'right',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'font-family',
        type: 'text'
    },
    {
        name: 'font-url',
        type: 'text'
    },
    {
        name: 'font-size',
        type: 'text',
        showUnits: true
    },
    {
        name: 'font-weight',
        type: 'text'
    },
    {
        name: 'min-height',
        type: 'text',
        showUnits: true
    },
    {
        name: 'height',
        type: 'text',
        showUnits: true
    },
    {
        name: 'min-width',
        type: 'text',
        showUnits: true
    },
    {
        name: 'width',
        type: 'text',
        showUnits: true
    },
    {
        name: 'margin',
        type: 'text',
        showUnits: true
    },

    {
        name: 'margin-top',
        type: 'text',
        showUnits: true
    },

    {
        name: 'margin-right',
        type: 'text',
        showUnits: true
    },

    {
        name: 'margin-bottom',
        type: 'text',
        showUnits: true
    },
    {
        name: 'margin-left',
        type: 'text',
        showUnits: true
    },
    {
        name: 'overflow',
        type: 'select',
        options: [
            'hidden',
            'visible',
            'initial',
            'inherit',
            'auto'
        ]
    },
    {
        name: 'overflow-x',
        type: 'select',
        options: [
            'hidden',
            'visible',
            'initial',
            'inherit',
            'auto'
        ]
    },
    {
        name: 'overflow-y',
        type: 'select',
        options: [
            'hidden',
            'visible',
            'initial',
            'inherit',
            'auto'
        ]
    },
    {
        name: 'padding',
        type: 'text',
        showUnits: true
    },

    {
        name: 'padding-top',
        type: 'text',
        showUnits: true
    },

    {
        name: 'padding-right',
        type: 'text',
        showUnits: true
    },

    {
        name: 'padding-bottom',
        type: 'text',
        showUnits: true
    },
    {
        name: 'padding-left',
        type: 'text',
        showUnits: true
    },
    {
        name: 'justify-content',
        type: 'select',
        options: [
            'flex-start',
            'flex-end',
            'center',
            'space-between',
            'space-around',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'flex',
        type: 'select',
        options: [
            'flex-grow',
            'flex-shrink',
            'auto',
            'none',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'flex-direction',
        type: 'select',
        options: [
            'row',
            'row-reverse',
            'column',
            'column-reverse',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'flex-wrap',
        type: 'select',
        options: [
            'wrap',
            'nowrap',
            'wrap-reverse',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'object-fit',
        help: 'Cut off the sides of an image, preserving the aspect ratio, and fill in the space',
        type: 'select',
        options: [
            'fill',
            'contain',
            'cover',
            'none',
            'scale-down',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'opacity',
        type: 'text'
    },
    {
        name: 'position',
        type: 'select',
        options: [
            'absolute',
            'relative',
            'initial',
            'inherit'
        ]
    },
    {
        name: 'text-align',
        type: 'select',
        options: [
            'left',
            'right',
            'center',
            'inherit'
        ]
    },
    {
        name: 'top',
        type: 'text',
        showUnits: true
    },
    {
        name: 'right',
        type: 'text',
        showUnits: true
    },
    {
        name: 'bottom',
        type: 'text',
        showUnits: true
    },
    {
        name: 'left',
        type: 'text',
        showUnits: true
    },
    {
        name: '-webkit-transform',
        type: 'text'
    },
    {
        name: 'z-index',
        type: 'text'
    }
];
